import * as React from 'react'
// libs
// components
import Grid from '@mui/material/Grid2'
import { Avatar } from 'components/UI'
// constants
import { REVIEW_STATUSES } from 'constants/review'
import { TASKS_TYPES } from 'constants/home'
// context
import { TasksListBLContext } from 'containers/StrategyActions/components/TasksList/layers/BL'
// hooks
import { useCurrentUser } from 'hooks'
// themes
import { Chip, ReviewIcon } from 'themes/views/tables'
// views
import { Description, Details, Wrapper } from './views'
import { AvatarWrapper, Button, ButtonLabel, ProgressIndicator, TasksCount } from '../../views'
// utils
import get from 'lodash/get'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import { getChipColor, isCurrentUser } from 'utils/index'

const GRID_STYLE = { margin: '0 4px' }

const Plan: React.FC = () => {
  const { onActionButtonClick, plan, closestPlanTask, tasks } = React.useContext(TasksListBLContext)

  const user = useCurrentUser()

  const isReviewExist = !isEmpty(closestPlanTask)
  const reviewers = get(closestPlanTask, 'assignedPersons')
  const reviewStatus = get(closestPlanTask, 'review.status', REVIEW_STATUSES.NOT_STARTED)

  const canComplete =
    isReviewExist &&
    reviewers.some(({ id }) => isCurrentUser(id, user)) &&
    moment().isSameOrAfter(closestPlanTask.startPeriod, 'day')

  const handleActionButtonClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    onActionButtonClick({ ...plan, review: get(closestPlanTask, 'review'), type: TASKS_TYPES.REVIEW })
  }

  return (
    <Wrapper container alignItems={'center'} isTasksExist={!!tasks.length}>
      <Details>
        <Grid container>
          <Grid> {plan.name}</Grid>
          {!!tasks.length && <TasksCount>{`(${tasks.length})`}</TasksCount>}
        </Grid>
        {isReviewExist && (
          <Description>
            <Grid>PLAN</Grid>
            <Grid style={GRID_STYLE}>REVIEW</Grid>
            <ProgressIndicator>{reviewStatus.replace('_', ' ')}</ProgressIndicator>
          </Description>
        )}
      </Details>
      {isReviewExist && (
        <>
          <Chip
            rounded
            chipColor={getChipColor(closestPlanTask.dueDate, reviewStatus)}
            label={closestPlanTask.dueDate.format('D MMM YY')}
            icon={<ReviewIcon />}
          />

          <AvatarWrapper>
            {reviewers.map((reviewer) => (
              <Avatar key={reviewer.id} withHover user={reviewer} />
            ))}
          </AvatarWrapper>

          {canComplete && (
            <Button $isFullModal onClick={handleActionButtonClick}>
              <ButtonLabel>
                {reviewStatus === REVIEW_STATUSES.NOT_STARTED && 'START REVIEW'}
                {reviewStatus === REVIEW_STATUSES.IN_PROGRESS && 'FINISH REVIEW'}
                {reviewStatus === REVIEW_STATUSES.COMPLETE && 'UPDATE REVIEW'}
              </ButtonLabel>
            </Button>
          )}
        </>
      )}
    </Wrapper>
  )
}

export default Plan
